export default "__VITE_ASSET__D8cWk8$a__"